export default "__VITE_ASSET__DweBnMJi__"